var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"financeTabs"}},[(_vm.tabs.length > 0)?_c('tab-frame',{attrs:{"tabs":_vm.tabs}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }